<template>
  <div>
    <SelectOption
      v-if="!selectedOption"
      @select="selectedOption = $event"
      @close="close"
    />
    <PauseSubscription
      v-else-if="selectedOption === 'pause'"
      @close="close"
      @back="back"
    />
    <TryForFree
      v-else-if="selectedOption === 'try_for_free'"
      @close="close"
      @back="back"
    />
    <CancelSubscription
      v-else-if="selectedOption === 'cancel'"
      @close="close"
      @back="back"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useRouter } from 'vue-router';
import CancelSubscription from './cancel-subscription/index.vue';
import PauseSubscription from './pause-subscription/index.vue';
import SelectOption from './SelectOption.vue';
import TryForFree from './try-for-free/index.vue';

const props = defineProps<{
  parentRouteName: string;
}>();

const router = useRouter();
const close = () => {
  router.push({ name: props.parentRouteName });
};

const back = () => {
  selectedOption.value = null;
};

const selectedOption = ref<'cancel' | 'try_for_free' | 'pause' | null>(null);
</script>
